// import { createApi, fetchBaseQuery } from "@rtk-incubator/rtk-query";
import { createApi, fetchBaseQuery } from '@reduxjs/toolkit/query/react';
import { apiEndpoints } from 'Utils/ApiEndpoints';
import Toast from 'Utils/Toast';

const baseUrl = process.env.REACT_APP_BASE_URL;

const baseQueryWithReauth = async (args, api, extraOptions) => {
    let result = await fetchBaseQuery({
        baseUrl: baseUrl,
        prepareHeaders: (headers) => {
            // Example for setting token or any other headers
            const token = api.getState().auth?.authData?.token;
            if (token) {
                headers.set("Authorization", `Bearer ${token}`);
            }
            return headers;
        },
    })(args, api, extraOptions);

    // Handle error responses
    if (result?.error) {
        const { status, data } = result.error;

        if (status === 400) {
            // Display a toast message or any other error handling
            Toast('e', data?.message || 'Bad Request');
        }

        // You can handle other status codes similarly if needed
    }

    return result;
};
export const authApi = createApi({
    baseQuery: baseQueryWithReauth,
    reducerPath: 'authApi',
    endpoints: (builder) => ({
        login: builder.mutation({
            query: (credentials) => ({
                url: apiEndpoints?.loginUrl,
                method: "POST",
                body: credentials,
            }),
        }),
        signUp: builder.mutation({
            query: (userData) => ({
                url: apiEndpoints?.signUpUrl,
                method: 'POST',
                body: userData,
            }),
        }),
        forgetPassword: builder.mutation({
            query: (credentials) => ({
                url: apiEndpoints?.forgetUrl,
                method: 'POST',
                body: { ...credentials },
            }),
        }),
        verifyOtp: builder.mutation({
            query: (otpData) => ({
                url: apiEndpoints?.otpVerifyUrl,
                method: 'POST',
                body: otpData,
            }),
        }),
        resendOtp: builder.mutation({
            query: (credentials) => ({
                url: apiEndpoints?.resendOtpUrl,
                method: 'POST',
                body: { ...credentials },
            }),
        }),
        resetPassword: builder.mutation({
            query: (resetData) => ({
                url: apiEndpoints?.resetPasswordUrl,
                method: 'POST',
                body: resetData,
            }),
        }),
        getUserProfile: builder.query({
            query: () => ({
                url: apiEndpoints?.profileUrl,
                method: 'GET',
            }),
        }),
    }),
});

export const {
    useLoginMutation,
    useForgetPasswordMutation,
    useVerifyOtpMutation,
    useResendOtpMutation,
    useResetPasswordMutation,
    useSignUpMutation,
    useGetUserProfileQuery
} = authApi;